//job function selector
const placeholder = ``;

async function redirect(params){
    const qs = params.toString().replaceAll('%2C', ',').replaceAll('%3A', ':');
    const targetURL = window.location.pathname + ".json?" + qs;

    const element = document.getElementById('job-list');
    element.innerHTML = [placeholder, placeholder, placeholder].join('\n');
    element.classList.add('loading');

    const res = await fetch(targetURL);
    const data = await res.json();
    element.classList.remove('loading');
    console.log(data);

    const language = document.querySelector('html').getAttribute('lang');

    const list = data.map(it => `
<tr class="position-relative align-top">
    <td class="text-uppercase pe-2"><strong>${it.name}</strong></td>
    <td class="text-uppercase pe-3" nowrap="nowrap">${it.tags?.locations?.map(x => x.name).join(', ') || ''}</td>
    <td class="text-uppercase pe-2">${it.tags?.job_functions?.map(x => x.name).join(', ') || ''}</td>
    <td class="job-list-apply"><a class="job-apply-button ff-serif stretched-link" href="/${language}/jobs/${it.id}" data-id="${it.id}" data-action="panel-show" data-target="panel">APPLY</a></td>
</tr>
    `);

    element.innerHTML = list.join('\n');
    window.history.pushState({},"", window.location.pathname + "?" + qs);
    jobPanel.update();
//    window.location.href= window.location.pathname + "?" + params.toString().replaceAll('%2C', ',').replaceAll('%3A', ':')+ '#filter-select';
}

document.querySelectorAll('#filter-location').forEach(el =>{
    el.addEventListener('change', async () =>{
        const params = new URLSearchParams(window.location.search);
        const filterTags = (params.get('filter_by_tags') ?? ':').split(':');
        filterTags[0] = el.value;

        params.set('filter_by_tags', filterTags.join(':'));
        await redirect(params);
    });
});

document.querySelectorAll('#filter-job-function').forEach(el =>{
    el.addEventListener('change', async () =>{
        const params = new URLSearchParams(window.location.search);
        const filterTags = (params.get('filter_by_tags') ?? ':').split(':');
        filterTags[1] = el.value;

        params.set('filter_by_tags', filterTags.join(':'));
        await redirect(params);
    });
});

const language = document.querySelector('html').getAttribute('lang');

class Panel{
    constructor(id) {
        this.id = id;
        this.element = document.getElementById(id);
        this.btnNexts = this.element.querySelectorAll('*[data-action="panel-next"]');
        this.btnPrevs = this.element.querySelectorAll('*[data-action="panel-previous"]');

        this.btnNexts.forEach(el => el.addEventListener('click', ()=>this.next()));
        this.btnPrevs.forEach(el => el.addEventListener('click', ()=>this.prev()));
        this.update();
    }
    update(){
        this.btnShows = document.querySelectorAll(`*[data-action="panel-show"][data-target="${this.id}"]`);
        this.btnShows.forEach(el => el.addEventListener('click', evt => {
            evt.preventDefault();
            this.show(el.getAttribute('data-id'));
            return false;
        }));
    }
    next(){}
    prev(){}
    onShow(id){}
    show(id){
        document.body.classList.add('modal-open');
        this.element.classList.add('active');
        this.element.querySelectorAll('.scroll-long-text').forEach(el =>{
            el.scrollTo({top: 0});
        })
        this.onShow(id);
    }
}

const jobPanel = new Panel('panel');
jobPanel.onShow = (id) =>{
    fetch(`/${language}/api/jobs/${id}`).then(response => response.json().then(obj =>{
        console.log(obj.payload.body);
        const tokens = obj.payload.body.tokens;
        const tags = obj.payload.body.tags;

        document.querySelectorAll('#panel *[data-value="name"]').forEach(el => {
            el.innerHTML = tokens.name ?? "";
        });

        document.querySelectorAll('#panel *[data-value="tags.locations"]').forEach(el => {
            el.innerHTML = tags.locations.map(it=> it.name).join(',') ?? "";
        });

        document.querySelectorAll('#panel *[data-value="body"]').forEach(el => {
            el.innerHTML = tokens.body ?? "";
        });

        document.querySelectorAll('#panel *[data-value="notes"]').forEach(el => {
            el.innerHTML = tokens.notes ?? "";
        });

        document.querySelectorAll('#panel *[data-value="link"]').forEach(el => {
            el.innerHTML = tokens.link.label ?? "Details";
            el.setAttribute('href', tokens.link.url ?? "#") ;
        });

        document.querySelectorAll('#panel *[data-values="highlights"]').forEach(el => {
            el.innerHTML = tokens.highlights.map(it => `<li>${it.subject}</li>`).join("") ?? "";
        });

        document.querySelectorAll('#panel *[data-values="duties"]').forEach(el => {
            el.innerHTML = tokens.duties.map(it => `<li>${it.subject}</li>`).join("") ?? "";
        });

        document.querySelectorAll('#panel *[data-values="requirements"]').forEach(el => {
            el.innerHTML = tokens.requirements.map(it => `<li>${it.subject}</li>`).join("") ?? "";
        });

        document.querySelectorAll('#panel *[data-values="additional"]').forEach(el => {
            el.innerHTML = tokens.additional.map(it => `<li><div class="ff-serif">${it.subject}</div><div>${it.body}</div></li>`).join("") ?? "";
        });
    }))
}

document.querySelectorAll('a.item').forEach(el => {
    el.addEventListener('click', evt => {
        evt.preventDefault();
        const pageId = el.getAttribute('data-team-id');

        if(el.previousElementSibling){
            btnProfilePrev.classList.remove('disabled');
            profilePrev = ()=>el.previousElementSibling.click();
        }else{
            btnProfilePrev.classList.add('disabled');
        }

        if(el.nextElementSibling){
            btnProfileNext.classList.remove('disabled');
            profileNext = ()=>el.nextElementSibling.click();
        }else{
            btnProfileNext.classList.add('disabled');
        }

        panelPicture.style.backgroundImage = el.querySelector('.picture').style.backgroundImage;
        panelName.innerHTML = el.querySelector('.caption .name').innerHTML;
        panelPosition.innerHTML = el.querySelector('.caption .position').innerHTML;
//fetch
        panelBody.innerHTML = "loading...";




    })
})